import './_heading.scss';

// visualLevel sets the typography independently of the semantic level.
const Heading = ({ level = 1, visualLevel = undefined, children, className = '', ...props }) => {
  const safeLevel = Math.min(Math.max(Number(level) || 1, 1), 6);
  const HeadingTag = `h${safeLevel}`;
  const visualClass = visualLevel ? `Heading--visual-${visualLevel}` : '';

  // @ts-ignore
  return (
    <HeadingTag className={`Heading ${visualClass} ${className}`.replace(/\s+/g, ' ').trim()} {...props}>
      {children}
    </HeadingTag>
  );
};

export default Heading;
